import Select, { StylesConfig, components, OptionProps } from 'react-select';
import OptionTypeBase from 'react-select';

import { FiCheck } from 'react-icons/fi';

const Option: React.FC<OptionProps<OptionTypeBase>> = props => (
  <components.Option {...props} aria-label={`${props.label}`} tab-index={0}>
    <div
      className={`flex items-center justify-between ${props.isFocused ? 'focus-indicator' : ''}`}
      aria-label={`${props.label}`}
      tab-index={0}
    >
      {props.label}
      {props.isSelected && <FiCheck className="text-green-500 text-lg" />}
    </div>
  </components.Option>
);

interface CustomSelectProps {
  options:
    | OptionTypeBase[]
    | {
        label: string;
        value: string | number;
      }[];
  placeholder?: string;
  value?: any;
  onChange?: (option: OptionTypeBase | null) => void;
  name?: string;
  className?: string;
  onBlur?: () => void;
  onInputChange?: (e: any) => void;
}

const customStyles: StylesConfig<OptionTypeBase, false> = {
  control: provided => ({
    ...provided,
    backgroundColor: '#021C2F',
    borderRadius: '6px',
    borderColor: 'transparent',
    color: 'rgba(255, 255, 255, 0.50)',
  }),
  singleValue: provided => ({
    ...provided,
    color: 'rgba(255, 255, 255, 0.50)',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: '#7459C8',
    transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
    transition: 'transform 0.3s ease-in-out',
  }),
  menu: provided => ({
    ...provided,
    backgroundColor: '#021C2F',
  }),
  option: (provided, state) => ({
    ...provided,
    borderBottom: '2px solid #022138',
    margin: '0 auto',
    color: 'rgba(255, 255, 255, 0.50)',
    backgroundColor: state.isFocused ? '#022138' : '#021C2F',
    '&:hover': {
      backgroundColor: '#022138',
    },
    '&:focus': {
      backgroundColor: '#021C2F',
    },
    '&:active': {
      backgroundColor: '#021C2F',
    },
  }),
  input: provided => ({
    ...provided,
    color: 'white',
  }),
};

function CustomSelect({ options, placeholder, value, onChange, name, className, onBlur, onInputChange }: CustomSelectProps) {
  return (
    <Select
      onInputChange={onInputChange}
      onBlur={onBlur}
      value={value}
      onChange={onChange}
      options={options}
      styles={customStyles}
      placeholder={placeholder}
      name={name}
      components={{ Option }}
      className={className}
      isSearchable
    />
  );
}

export default CustomSelect;
